// extracted by mini-css-extract-plugin
module.exports = {"group":"Delivery_group__1IlKL"};